import { useCallback } from 'react';

const noop = () => {};

export const useActionEffects = <T extends any[], U>(
  action: (...args: T) => Promise<U>,
  onResolve: (result: U) => void = noop,
  onError: (error: Error) => void = noop
) => {
  return useCallback(
    (...args: T) => {
      return action(...args)
        .then((val) => {
          onResolve(val);
          return val;
        })
        .catch((error: Error) => {
          onError(error);
          return Promise.reject(error);
        });
    },
    [action, onResolve, onError]
  );
};
